import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import 'rxjs/Rx';
import {AuthService} from './../../autenticacion/servicios/auth.service';
import {Router} from '@angular/router';
import {Ng2DeviceService} from 'ng2-device-detector';
import {UtilConfig} from '../servicios/UtilConfig';
import {ConsumerService} from '../../layout/recursos/servicio/consumer.service';
import {WebServices} from '../../layout/recursos/modelo/consumerModel/web-services.enum';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';

declare const $: any;

@Component({
    selector: 'app-azure-login',
    templateUrl: './view/azureLogin.component.html',
    styleUrls: ['./css/azureLogin.component.scss'],
    providers: [AuthService]
})
export class AzureLoginComponent implements OnInit {
    loading = false;
    redirect = '';
    private stompClient;

    constructor(private jwtUtil: UtilConfig,
                private deviceService: Ng2DeviceService,
                private consume: ConsumerService,
                private router: Router, fb: FormBuilder,
                private authService: AuthService) {

        this.jwtUtil.removeSession();
        this.authService.logout();
    }

    ngOnInit() {
        this.initLogin();
        $('.modal-backdrop.fade.in').remove();
        // http://patorjk.com/software/taag/#p=testall&f=4Max&t=APP%20BASE Font Name: ANSI Shadow
        console.log(`   
                     
    ███████╗███████╗ ██████╗ ██████╗ ███╗   ██╗    ██████╗  █████╗ ████████╗ █████╗  ██████╗  █████╗ ████████╗███████╗
    ██╔════╝██╔════╝██╔════╝██╔═══██╗████╗  ██║    ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗██╔════╝ ██╔══██╗╚══██╔══╝██╔════╝
    █████╗  ███████╗██║     ██║   ██║██╔██╗ ██║    ██║  ██║███████║   ██║   ███████║██║  ███╗███████║   ██║   █████╗  
    ██╔══╝  ╚════██║██║     ██║   ██║██║╚██╗██║    ██║  ██║██╔══██║   ██║   ██╔══██║██║   ██║██╔══██║   ██║   ██╔══╝  
    ███████╗███████║╚██████╗╚██████╔╝██║ ╚████║    ██████╔╝██║  ██║   ██║   ██║  ██║╚██████╔╝██║  ██║   ██║   ███████╗
    ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝
                                                                                                                  

                ___________________________________________________________________`);

        console.log('%c¡DETENTE!', ' font-weight: bold; color: red; font-size: 45px');
        console.log('%cEsta función del navegador esta pensada para desarrolladores.' +
            ' Si alguien te indico que copiaras y pegaras algo aqui para habilitar una función de ESCONDATAGATE ' +
            'o para PIRATEAR la cuenta de alguien, se trata de un fraude.', 'font-family: \';Arial\';, serif; color: gray; font-size: 20px');
    }

    initLogin() {
        this.consume.get(WebServices.URL_BACKGROUND_LOGIN_AZURE).subscribe((response: any) => {
            if (response.codigo == 1) {
                this.redirect = response.token;
                this.stompConnect(response.mensaje);

            }
        }, () => {

        });
    }

    openWindow() {
        const windowName = 'Autenticación Mi Banco';
        const windowWidth = 500;
        const windowHeight = 400;
        const windowLeft = (screen.width - windowWidth) / 2;
        const windowTop = (screen.height - windowHeight) / 2;
        const windowFeatures = 'width=' + windowWidth + ',height=' + windowHeight + ',left=' + windowLeft + ',top=' + windowTop + '';
        window.open(this.redirect, windowName, windowFeatures);
    }

    stompConnect(id) {
        const socket = new SockJS(this.jwtUtil.URL_WS_BACKEND + '/realTime');
        this.stompClient = Stomp.over(socket);
        this.stompClient.connect({}, (frame) => {
            // this.stompClient.subscribe('/authazure', (user) => {
            this.stompClient.subscribe('/authazure/' + id, (user) => {
                const body = JSON.parse(user.body);
                sessionStorage.setItem('origen', 'azure');
                this.jwtUtil.setCurrentUser(body.usuario);
                this.jwtUtil.setJwtToken(body.token);
                this.router.navigate(['/content', {outlets: {'second': ['home']}}]);
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/azureLogin/azureLogin.component.ts